import Categories from './Categories';
import Contents from './Contents';

function Body(props) {
  return (
    <div className="products__body-container">
      <div className="products__body-wrapper row">
        <div className="products__body-categories">
          <Categories />
        </div>
        <div className="products__body-contents">
          <Contents {...props} />
        </div>
      </div>
    </div>
  );
}

export default Body;
